import {
    Button,
    Container,
    Form,
    InputGroup,
    Stack,
} from "react-bootstrap";
import "./main.css";
import Header from "../header";
import { useEffect, useState } from "react";
import { SiteList } from "../../axi";
import SiteCard from "../card";
import FormAdd from "../form";

export default function Main({setIsAuthenticated}) {
    // прослушка изменений для отражения данных в реальном времени при изменении списка
    const [wiretapping, setWiretapping] = useState(false);

    const [site, setsite] = useState([]);
    const [stack, setstack] = useState([]);
    const [provider, setprovider] = useState([]);
    const [load, setload] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [redactId, setredactId] = useState({});
    const [formAdd, setFormAdd] = useState(false);

    const handleLoadLIst = async () => {
        const rezult = await SiteList();
        console.log(rezult);

        if (Array.isArray(rezult.list)) {
            setsite(rezult.list);
            setstack(rezult.stack);
            setprovider(rezult.provider);
            setload(true);
        } else {
            setload(false);
        }
    };
    const findMatches = (arr1, arr2) => {
        return arr1.filter((obj1) =>
            arr2.some((obj2) => obj2 === obj1.id)
        );
    };

    useEffect(() => {
        handleLoadLIst();
    }, []);
    useEffect(() => {
        handleLoadLIst();
    }, [wiretapping]);
    
    useEffect(() => {}, [load]);
    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
        
    };

    const taskRedact = (e)=>{
        setFormAdd(!formAdd);
        setredactId(e)
    }

    const filteredSites = site.filter(
        (item) =>
            item.name
                .toLowerCase()
                .includes(searchText.toLowerCase()) ||
            item.url
                .toLowerCase()
                .includes(searchText.toLowerCase())
    );
  
    return (
        <>
            <Header setIsAuthenticated={setIsAuthenticated}/>
            <main>
                <Container>
                    <Stack
                        direction="horizontal"
                        className="mt-5"
                        gap={2}
                    >
                        <InputGroup className=" me-auto ">
                            <InputGroup.Text
                                onClick={() =>
                                    document
                                        .querySelector(
                                            "#serch"
                                        )
                                        .focus()
                                }
                            >
                                <svg
                                    className="serch"
                                    xmlns="http://www.w3.org/2000/svg"
                                    x="0px"
                                    y="0px"
                                    width="100"
                                    height="100"
                                    viewBox="0 0 64 64"
                                >
                                    <path d="M 25 0 C 11.214844 0 0 11.214844 0 25 C 0 38.785156 11.214844 50 25 50 C 30.515625 50 35.613281 48.203125 39.75 45.167969 C 39.75 45.167969 42.527344 47.886719 42.660156 47.933594 C 42.660156 47.957031 42.65625 47.976563 42.65625 48 C 42.65625 49.335938 43.175781 50.59375 44.121094 51.535156 L 54.464844 61.878906 C 55.441406 62.855469 56.71875 63.339844 58 63.339844 C 59.28125 63.339844 60.5625 62.855469 61.535156 61.878906 L 61.878906 61.53125 C 62.824219 60.589844 63.34375 59.335938 63.34375 58 C 63.34375 56.664063 62.824219 55.40625 61.878906 54.464844 L 51.535156 44.121094 C 50.542969 43.128906 49.238281 42.648438 47.9375 42.667969 C 47.886719 42.53125 45.167969 39.75 45.167969 39.75 C 48.203125 35.613281 50 30.515625 50 25 C 50 11.214844 38.785156 0 25 0 Z M 25 2 C 37.683594 2 48 12.316406 48 25 C 48 37.683594 37.683594 48 25 48 C 12.316406 48 2 37.683594 2 25 C 2 12.316406 12.316406 2 25 2 Z M 25 6 C 19.925781 6 15.152344 7.976563 11.5625 11.5625 C 4.15625 18.972656 4.15625 31.027344 11.5625 38.433594 C 15.152344 42.023438 19.925781 44 25 44 C 30.074219 44 34.847656 42.023438 38.4375 38.4375 C 45.84375 31.027344 45.84375 18.972656 38.4375 11.5625 C 34.847656 7.976563 30.074219 6 25 6 Z M 25 8 C 29.539063 8 33.808594 9.769531 37.019531 12.980469 C 43.648438 19.605469 43.648438 30.394531 37.019531 37.019531 C 33.808594 40.230469 29.539063 42 25 42 C 20.460938 42 16.191406 40.230469 12.980469 37.019531 C 6.351563 30.394531 6.351563 19.609375 12.980469 12.980469 C 16.191406 9.769531 20.460938 8 25 8 Z M 24.808594 11 C 21.171875 11.042969 17.703125 12.496094 15.097656 15.097656 C 14.707031 15.492188 14.707031 16.121094 15.097656 16.515625 C 15.292969 16.707031 15.550781 16.808594 15.808594 16.808594 C 16.0625 16.808594 16.320313 16.707031 16.515625 16.515625 C 19.0625 13.964844 22.582031 12.703125 26.179688 13.058594 C 26.730469 13.105469 27.21875 12.710938 27.273438 12.160156 C 27.328125 11.609375 26.925781 11.121094 26.375 11.066406 C 25.851563 11.015625 25.328125 10.992188 24.808594 11 Z M 31.859375 12.875 C 31.476563 12.820313 31.074219 12.996094 30.859375 13.351563 C 30.574219 13.824219 30.726563 14.4375 31.203125 14.722656 C 32.023438 15.222656 32.792969 15.824219 33.484375 16.515625 C 33.679688 16.710938 33.933594 16.808594 34.191406 16.808594 C 34.449219 16.808594 34.703125 16.710938 34.902344 16.515625 C 35.289063 16.125 35.289063 15.492188 34.902344 15.101563 C 34.09375 14.296875 33.195313 13.59375 32.234375 13.011719 C 32.117188 12.941406 31.988281 12.894531 31.859375 12.875 Z M 11 24 C 10.449219 24 10 24.445313 10 25 C 10 25.554688 10.449219 26 11 26 L 13 26 C 13.550781 26 14 25.554688 14 25 C 14 24.445313 13.550781 24 13 24 Z M 37 24 C 36.449219 24 36 24.445313 36 25 C 36 25.554688 36.449219 26 37 26 L 39 26 C 39.550781 26 40 25.554688 40 25 C 40 24.445313 39.550781 24 39 24 Z M 13.890625 28.496094 C 13.761719 28.492188 13.625 28.515625 13.5 28.566406 L 11.644531 29.316406 C 11.132813 29.523438 10.886719 30.105469 11.09375 30.617188 C 11.25 31.007813 11.625 31.246094 12.019531 31.246094 C 12.144531 31.246094 12.273438 31.222656 12.394531 31.171875 L 14.25 30.421875 C 14.761719 30.214844 15.007813 29.632813 14.800781 29.121094 C 14.644531 28.738281 14.28125 28.5 13.890625 28.496094 Z M 36.046875 28.6875 C 35.65625 28.6875 35.285156 28.917969 35.125 29.296875 C 34.910156 29.808594 35.144531 30.394531 35.65625 30.609375 L 37.496094 31.390625 C 37.621094 31.445313 37.753906 31.46875 37.886719 31.46875 C 38.277344 31.46875 38.644531 31.242188 38.808594 30.859375 C 39.023438 30.351563 38.785156 29.765625 38.277344 29.550781 L 36.4375 28.769531 C 36.308594 28.714844 36.175781 28.6875 36.046875 28.6875 Z M 16.515625 32.484375 C 16.257813 32.484375 16.003906 32.582031 15.808594 32.777344 L 14.394531 34.191406 C 14.003906 34.582031 14.003906 35.214844 14.394531 35.605469 C 14.589844 35.800781 14.84375 35.898438 15.101563 35.898438 C 15.359375 35.898438 15.613281 35.800781 15.808594 35.605469 L 17.222656 34.191406 C 17.613281 33.800781 17.613281 33.167969 17.222656 32.777344 C 17.027344 32.582031 16.769531 32.484375 16.515625 32.484375 Z M 33.484375 32.484375 C 33.230469 32.484375 32.972656 32.582031 32.777344 32.777344 C 32.386719 33.167969 32.386719 33.800781 32.777344 34.191406 L 34.191406 35.605469 C 34.386719 35.800781 34.640625 35.898438 34.898438 35.898438 C 35.15625 35.898438 35.410156 35.800781 35.605469 35.605469 C 35.996094 35.214844 35.996094 34.582031 35.605469 34.191406 L 34.191406 32.777344 C 33.996094 32.582031 33.738281 32.484375 33.484375 32.484375 Z M 20.3125 35.046875 C 19.921875 35.046875 19.550781 35.273438 19.390625 35.65625 L 18.609375 37.496094 C 18.394531 38.003906 18.632813 38.59375 19.140625 38.808594 C 19.269531 38.863281 19.398438 38.886719 19.53125 38.886719 C 19.917969 38.886719 20.289063 38.65625 20.453125 38.277344 L 21.234375 36.4375 C 21.449219 35.929688 21.210938 35.339844 20.703125 35.125 C 20.574219 35.070313 20.441406 35.046875 20.3125 35.046875 Z M 29.511719 35.125 C 29.382813 35.125 29.246094 35.148438 29.121094 35.199219 C 28.605469 35.40625 28.359375 35.988281 28.566406 36.5 L 29.316406 38.355469 C 29.472656 38.746094 29.847656 38.980469 30.246094 38.980469 C 30.371094 38.980469 30.496094 38.957031 30.621094 38.90625 C 31.132813 38.699219 31.378906 38.117188 31.171875 37.605469 L 30.421875 35.75 C 30.265625 35.367188 29.902344 35.132813 29.511719 35.125 Z M 25 36 C 24.449219 36 24 36.445313 24 37 L 24 39 C 24 39.554688 24.449219 40 25 40 C 25.550781 40 26 39.554688 26 39 L 26 37 C 26 36.445313 25.550781 36 25 36 Z M 43.910156 41.324219 L 45.785156 43.203125 C 45.3125 43.4375 44.859375 43.730469 44.464844 44.125 L 44.121094 44.464844 C 43.730469 44.855469 43.4375 45.304688 43.199219 45.78125 L 41.324219 43.910156 C 42.25 43.113281 43.113281 42.25 43.910156 41.324219 Z M 48 44.65625 C 48.769531 44.65625 49.539063 44.949219 50.125 45.535156 L 60.46875 55.878906 C 61.035156 56.445313 61.34375 57.199219 61.34375 58 C 61.34375 58.800781 61.03125 59.554688 60.464844 60.121094 L 60.121094 60.464844 C 58.949219 61.632813 57.050781 61.632813 55.878906 60.464844 L 45.535156 50.121094 C 44.96875 49.554688 44.65625 48.800781 44.65625 48 C 44.65625 47.199219 44.96875 46.445313 45.535156 45.878906 L 45.878906 45.535156 C 46.464844 44.949219 47.234375 44.65625 48 44.65625 Z"></path>
                                </svg>
                            </InputGroup.Text>
                            <Form.Control
                                className="serch_inp me-auto "
                                id="serch"
                                placeholder="Поиск"
                                value={searchText}
                                onChange={
                                    handleSearchChange
                                }
                            />
                               
                        </InputGroup>

                        <Button
                            className="bek"
                            onClick={() => setFormAdd(true)}
                        >
                            +Добавить
                        </Button>
                    </Stack>
                    <div className="site_grid mb-5 mt-5">
                        {load ? (
                            filteredSites.map((e) => (
                                <SiteCard
                                    e={e}
                                    key={e.id}
                                    setWiretapping={()=>setWiretapping(!wiretapping)}
                                    provider={
                                        typeof e.provider_id ===
                                            "object" &&
                                        e.provider_id !==
                                            null &&
                                        provider.find(
                                            (obj) =>
                                                obj.id ===
                                                e
                                                    .provider_id
                                                    .domen_id
                                        )
                                    }
                                    hosts={
                                        typeof e.provider_id ===
                                            "object" &&
                                        e.provider_id !==
                                            null &&
                                        provider.find(
                                            (obj) =>
                                                obj.id ===
                                                e
                                                    .provider_id
                                                    .hosts_id
                                        )
                                    }
                                    stack={
                                        typeof e.stack_id ===
                                            "object" &&
                                        e.stack_id !==
                                            null &&
                                        findMatches(
                                            stack,
                                            e.stack_id
                                        )
                                    }
                                    taskRedact={taskRedact}
                                />
                            ))
                        ) : (
                            <div>УХТЫЖЁБАНОРОТ</div>
                        )}
                    </div>
                </Container>
                <FormAdd
                    show={formAdd}
                    onHide={() => {setFormAdd(false); setredactId({})}}
                    provider={provider}
                    setWiretapping={()=>setWiretapping(!wiretapping)}
                    element = {redactId}
                />
                
            </main>
        </>
    );
}
